import { buildAngularAuthConfig, LogtoAngularConfig } from '@logto/angular';
import { LogLevel, StsConfigStaticLoader } from 'angular-auth-oidc-client';
import { AppConfigService } from '../../services/app-config.service';

export const getAuthenticationConfig = ({ appConfig }: AppConfigService, window: Window): StsConfigStaticLoader => {
  const { origin } = window.location;

  const logtoAngularConfig: LogtoAngularConfig = {
    endpoint: appConfig.auth.endpoint,
    appId: appConfig.auth.appId,
    redirectUri: `${origin}${appConfig.auth.redirectUri}`,
    postLogoutRedirectUri: origin,
    scopes: appConfig.auth.scopes,
    resource: appConfig.auth.resource,
  };

  if (appConfig.auth.extraParams) {
    logtoAngularConfig.extraParams = appConfig.auth.extraParams;
  }

  const cvAuthConfig = buildAngularAuthConfig(logtoAngularConfig);
  cvAuthConfig.secureRoutes = [appConfig.azure.proxy_base_url];
  cvAuthConfig.configId = appConfig.auth.configId;
  cvAuthConfig.ignoreNonceAfterRefresh = true;
  cvAuthConfig.maxIdTokenIatOffsetAllowedInSeconds = 600;

  return new StsConfigStaticLoader({
    ...cvAuthConfig,
    silentRenew: true,
    useRefreshToken: true,
    renewUserInfoAfterTokenRenew: true,
    renewTimeBeforeTokenExpiresInSeconds: 900,
    logLevel: LogLevel.Debug,

    /* EXPERIMENT 1 – stop URL rewrite loops */
    historyCleanupOff: true, // keep the original callback URL

    /* EXPERIMENT 2 – disable the iframe “session‑check” loop */
    startCheckSession: false,

    /* EXPERIMENT 3 – give silent‑renew more time before aborting */
    silentRenewTimeoutInSeconds: 10,

    /* EXPERIMENT 4 – let multiple tabs reuse the same refresh‑token */
    allowUnsafeReuseRefreshToken: true,
  });
};
